import { useNavigation } from "@react-navigation/native";
import React, { useState, useEffect, useCallback } from "react";
import { StyleSheet, Text, View } from "react-native";
import WebView from "@components/WebView";

import testIds from "../../constants/testIds";

import BackButton from "@components/BackButton";
const WebViewPage = ({ route = {} }) => {
  const { params = {} } = route;
  const navigation = useNavigation();

  return (
    <>
      {params.showHeader === "true" ? (
        <View
          testID={testIds.webview_container}
          style={{
            backgroundColor: "white",
            borderBottomColor: "rgba(0,0,0,0.1)",
            borderBottomWidth: 1,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <BackButton onPress={navigation.goBack} />
          <Text
            style={{
              fontWeight: "bold",
              fontSize: 16,
              paddingVertical: 20,
              paddingLeft: 15,
            }}
          >
            {decodeURIComponent(params.title).replace(/\+/g, " ")}
          </Text>
        </View>
      ) : null}
      <WebView
        url={decodeURIComponent(params.url)}
        useToken={params.useToken}
      />
    </>
  );
};

export default WebViewPage;

const styles = StyleSheet.create({});
